import React from "react";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Notification } from "orcs-design-system";
import { useOrgAnnouncement } from "src/hooks/orgConfig/hooks/useOrgAnnouncement";
import { colourToNotificationVariant } from "./notificationColour";

// Top-banner only — not a kit pattern. Drops the accent bar, border-radius and centres copy.
const TopBannerNotification = styled(Notification)`
  justify-content: center;
  text-align: center;
  padding-left: ${themeGet("space.s")};
  border-radius: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  &::before {
    content: none;
  }
`;

const GlobalNotification = () => {
  const { announcement } = useOrgAnnouncement();
  const { message, colour, visualTreatment } = announcement ?? {};

  switch (visualTreatment) {
    case "top-banner":
      return (
        <TopBannerNotification
          id="notification-top-banner"
          data-testid="notification-top-banner"
          variant={colourToNotificationVariant(colour)}
          noIcon
          closable={false}
          width="100%"
        >
          {message}
        </TopBannerNotification>
      );
    case "bottom-banner":
      return (
        <Notification
          floating
          centered
          bottom="20px"
          variant={colourToNotificationVariant(colour)}
          closable={false}
          noIcon
        >
          {message}
        </Notification>
      );
    default:
      return null;
  }
};

export default GlobalNotification;
